export const SET_CINEMA_SOLON = "SET_CINEMA_SOLON"
export const CHANGE_DELIVERY_ADDRESS = "CHANGE_DELIVERY_ADDRESS"
export const SET_DELIVERY_AREA_NAME = "SET_DELIVERY_AREA_NAME"
export const CHANGE_DELIVERY_TYPE = "CHANGE_DELIVERY_TYPE"
export const CHANGE_DELIVERY_SERVICE = "CHANGE_DELIVERY_SERVICE"
export const CLEAR_DELIVERY_INFO = "CLEAR_DELIVERY_INFO"
export const CLEAR_DELIVERY_ADDRESS = "CLEAR_DELIVERY_ADDRESS"
export const SET_SNAPBOX_DELIVERY_QUOTATION = "SET_SNAPBOX_DELIVERY_QUOTATION"